const mobileMax = 720;
const mobileLandscapeMax = 896;
const desktopLgMin = 1440;

export default {
  desktopLgMin,
  mobileLandscapeMax,
  mobileMax,
};
